<template>
  <div class="layerPop" id="popAddition" v-if="isVisible">
    <div class="popWrap">
      <div class="popBox popType1">
        <div class="popHead">
          <p class="popTit">부가담보</p>
        </div>
        <div class="popCon">
          <div class="conStyle1">
            <p class="tit mgt0">부가담보 선택하세요.</p>
          </div>

          <div class="tabStyle2">
            <table>
              <caption>
                부가담보 선택
              </caption>
              <colgroup>
                <col width="62" />
                <col width="100" />
                <col width="*" />
                <col width="80" />
                <col width="130" />
                <col width="80" />
              </colgroup>
              <thead>
                <tr>
                  <th scope="col" class="tar" height="50"></th>
                  <th scope="col">담보코드</th>
                  <th scope="col">담보명</th>
                  <th scope="col" colspan="3">추가사항</th>
                </tr>
              </thead>

              <tbody>
                <tr
                  v-for="(d, index) in state.insCondOutputVoList"
                  :key="index"
                >
                  <td class="tar" height="60">
                    <div class="inpCheck">
                      <input
                        type="checkbox"
                        :id="'item-' + index"
                        v-model="d.checked"
                        @change="onclick(state.insCondOutputVoList, d)"
                      />
                      <label :for="'item-' + index" class="pdl20"
                        ><span class="hide">선택</span></label
                      >
                    </div>
                  </td>
                  <td>{{ d.addtlCovCd }}</td>
                  <td class="tal">{{ d.addtlCovNm }}</td>
                  <td class="bg">{{ d.addTrm1 }}</td>
                  <td>
                    <div class="inpSlt" v-show="d.addTrmVal1 != ''">
                      <button type="button" class="sltBtn" title="조건 선택">
                        <span></span>
                      </button>
                      <ul>
                        <li
                          v-for="(item, index) in d.addTrmVal1.split('^')"
                          :key="index"
                        >
                          <button
                            type="button"
                            class="sltOpt"
                            title="선택"
                            @click="test(d, item)"
                          >
                            <span>{{ item }}</span>
                          </button>
                        </li>
                        <!-- 체크되어있는 버튼에 title="선택" 추가 -->
                      </ul>
                    </div>
                  </td>
                  <td class="bg">{{ d.addTrmUnt1 }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="popBtn">
          <a class="btnType sizeS colorB" @click="send()"><span>확인</span></a>
        </div>
        <slot></slot>
        <button type="button" class="popClose" @click="close()">
          <span class="hide">닫기</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, defineEmits, inject, defineExpose, reactive } from "vue";
import { format } from "date-fns";

const swalAlert = inject("swalAlert");
const axios = inject("axios");
const isVisible = ref(false);
const state = reactive({
  insCondOutputVoList: [],
});

const emits = defineEmits(["update:data", "close"]);

const open = async (object) => {
  let strItmCd = object.itmCd; // 품목코드   				v
  let strPackCd = object.packCd; // 포장코드  				v
  let strBasCndCd = object.basCndCd; // 기본조건코드			v
  let strVygZone = object.vygZone; // 항해구역				v
  let strPdCd = object.pdCd; // 상품코드				v
  let strDtlsDivCd = object.dtlsDivCd; // 세부구분코드			v
  let strFtrnOdDivCd = object.ftrnOdDivCd;
  let strBasSicDivCd = object.basSicDivCd;
  let strCrGddcDivCd = object.crGddcDivCd; // 요율안내문구분코드
  let strAcpShCd = ""; // 인수형태코드			v
  let strEndrYn = ""; // 배서여부
  let strFletShpQt = "0"; // 선단선박수량
  let strMdadAmt = ""; // 기계손해추가공제금액
  let strPrdSectDiv = ""; // 기간구간구분
  let strPyCycCd = ""; // 납입주기코드
  let strTtTnNum = ""; // 총톤수
  let bizNo = ""; // 사업자번호
  let insStdt = format(new Date(), "yyyyMMdd"); // 청약일자

  var voMap = {};
  voMap.itmCd = strItmCd;
  voMap.packCd = strPackCd;
  voMap.basCndCd = strBasCndCd;
  voMap.vygZone = strVygZone;
  voMap.pdCd = strPdCd;
  voMap.dtlsDivCd = strDtlsDivCd;

  voMap.ftrnOdDivCd = strFtrnOdDivCd;
  voMap.basSicDivCd = strBasSicDivCd;
  voMap.crGddcDivCd = strCrGddcDivCd;
  voMap.acpShCd = strAcpShCd;
  voMap.endrYn = strEndrYn;
  voMap.fletShpQt = strFletShpQt;
  voMap.mdadAmt = strMdadAmt;
  voMap.prdSectDiv = strPrdSectDiv;
  voMap.pyCycCd = strPyCycCd;
  voMap.ttTnNum = strTtTnNum;
  voMap.bizNo = bizNo;
  voMap.sbcpDt = insStdt;
  const result = await axios.transaction("FNGCTNFO0025", voMap);
  state.insCondOutputVoList = result.body.row;

  //부가조건 자동 체크
  state.insCondOutputVoList.forEach((d) => {
    if(d.mdtrYn == 'Y'){
      d.checked = true
    }
  })

  isVisible.value = true;
};

const send = () => {
  let filterObject = _.filter(state.insCondOutputVoList, function (info) {
    return info.checked == true;
  });

  isVisible.value = false;
  emits("update:data", { filterObject });
};
const onclick = (list, data) => {
  let filterObject = _.filter(list, function (info) {
    return info.checked == true;
  });

  if (filterObject.length > 4) {
    swalAlert(
      "부가담보 4까지 선택이 가능합니다.\n업무부로 문의 해 주십시오.\n문의전화 : 02-6464-3216, 3218, 3219, 3222, 3226"
    );
    data.checked = false;
  }
};

const test = (data, text) => {
  data.text = text;
};

const close = () => {
  isVisible.value = false;
  emits("close");
};

defineExpose({ open, close });
</script>
